import Axios from "axios";
import { ApiBaseUrl, Customer } from "../config/config";
import { ApiResultModel } from "../models/common.model";
import {
  customerInformationRequest,
  customerInformationResponse,
  verifyCustomerInformationRequest,
  verifyCustomerInformationResponse,
} from "../models/customer.model";

export const SendOtpForGetCustomerInformation = (
  data: customerInformationRequest
): Promise<ApiResultModel<customerInformationResponse>> => {
  return Axios.post<ApiResultModel<customerInformationResponse>>(
    ApiBaseUrl + Customer + "/SendOtpForGetCustomerInformation",
    data
  ).then((result) => {
    return result.data;
  });
};

export const VerifyOtpForGetCustomerInformation = (
  data: verifyCustomerInformationRequest
): Promise<ApiResultModel<verifyCustomerInformationResponse>> => {
  return Axios.post<ApiResultModel<verifyCustomerInformationResponse>>(
    ApiBaseUrl + Customer + "/VerifyOtpForGetCustomerInformation",
    data
  ).then((result) => {
    return result.data;
  });
};
